import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'cmn-consent',
    templateUrl: './consent.component.html',
    styleUrls: ['./consent.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ConsentComponent),
        multi: true
    }]
})
export class ConsentComponent implements OnInit, ControlValueAccessor {

    @Input() field: any;
    @Input() readOnly: boolean = false;

    public checked: boolean = false;
    public disabled: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }

    onChange: any = () => {
    };
    onTouched: any = () => {
    };

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: boolean): void {
        if(!isNullOrUndefined(value)) {
            this.checked = value;
        }
    }

    public valueChange() {
        this.onChange(this.checked);
    }
}
